// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"c80afb69","510":"e80f2482","527":"8fb52cfc","619":"4d0ef207","881":"8c2bc698"}[chunkId] + ".chunk.js";
};